import React from 'react'
import { ArticlePage } from '../cmsPageState'
import { Image } from '../../../utils/images'
import {
  pageheaderArticleSrc,
  pageheaderArticleSrcSet
} from '../../../utils/imageSizes'
import { getImageUrls } from '../../../utils/sharepointImageUrls'
import { formatDateDDMMYYYY } from '../../../utils/date'

type ArticlePageHeaderProps = {
  readSpeakerCookieAccepted: boolean
  extraJSXBelowTitle?: React.ReactNode
  extraJSXBelowIntro?: React.ReactNode
  extraJSXBelowText?: React.ReactNode
} & ArticlePage

export const ArticlePageHeader = (props: ArticlePageHeaderProps) => {
  const { image, title, magazine } = props

  return (
    <header className="articleph">
      <div className="articleph__visual" aria-hidden="true">
        {image ? (
          <div className="container--l gutter--m">
            <div className="articleph__media">
              <Image
                src={pageheaderArticleSrc}
                srcset={pageheaderArticleSrcSet}
                lazyload={false}
                sizes={'100vw'}
                urls={getImageUrls(image)}
                classNames={{
                  image: ''
                }}
                width={'1240'}
                height={'420'}
                keepOriginalSize={false}
              />
              <svg
                className="magazine-icon"
                width="92px"
                height="92px"
                aria-hidden="true"
              >
                <use
                  xlinkHref={
                    magazine === 'Globe' ? '#icon--corner-g' : '#icon--corner-l'
                  }
                />
              </svg>
            </div>
          </div>
        ) : (
          <>
            <div className="icon-helper">
              <div className="container--l gutter--m">
                <div className="articleph__media">
                  <svg
                    className="magazine-icon"
                    width="56px"
                    height="76px"
                    aria-hidden="true"
                  >
                    <use
                      xlinkHref={
                        magazine === 'Globe'
                          ? '#icon--straight-g'
                          : '#icon--straight-l'
                      }
                    />
                  </svg>
                </div>
              </div>
            </div>
            <img
              className="image-placeholder no-lazyload"
              width="100%"
              height="420"
              alt=""
              src="/images/article-header-placeholder-large.png"
              data-src={'/images/article-header-placeholder-large.png'}
              data-srcset={
                '/images/article-header-placeholder-large.png 720w, /images/article-header-placeholder-large.png 1440w, /images/article-header-placeholder-large.png 2880w'
              }
              data-sizes="100vw"
            />
          </>
        )}
      </div>
      <div
        className={`articleph__container ${
          image ? 'container--with-image' : 'container--wo-image'
        }`}
      >
        <div className="articleph__inner">
          <p className="articleph__date">
            {formatDateDDMMYYYY(props.articleDate)}
          </p>
          <h1 className="articleph__title title--l">{title}</h1>
          <span className="articleph__highlightedLetter">
            {title.slice(0, 1)}
          </span>
        </div>
      </div>
    </header>
  )
}
